export { useHover } from './useHover';

export function wait(timeout) {
  return new Promise(resolve => setTimeout(() => resolve(timeout), timeout));
}
